// extracted by mini-css-extract-plugin
export default {"zr-image":"Image_zr-image__VUk0A"};